import React from 'react';
import { Card, SaveButton, useSection } from '../AdminUI';
import { ListEditor } from './NavigationSection';

/**
 * Available on-page anchors that any sidebar (or top-nav) item can link to.
 * Admin sees this list inline so they know which `#anchor` values produce a
 * working in-page jump.
 */
const PAGE_ANCHORS = [
  { id: '#gamecards-grid', label: 'Service Cards section' },
  { id: '#products', label: 'Products (B2C / B2B)' },
  { id: '#platforms', label: 'Platforms Showcase' },
  { id: '#promotions', label: 'Promotions' },
  { id: '#features', label: 'Feature Cards' },
  { id: '#inplay', label: 'Top Platforms' },
  { id: '#footer', label: 'Footer' },
];

export default function SidebarSection() {
  const [local, setLocal, save] = useSection('sidebar');
  return (
    <Card
      title="Left Sidebar"
      desc="Categories shown in the left rail on desktop & inside the mobile menu. Each item filters the storefront to matching labels and can also deep-link to a #section anchor."
      footer={<SaveButton onClick={save} />}
    >
      <ListEditor items={local} setItems={setLocal} fields={[
        { key: 'label', label: 'Label' },
        { key: 'icon', label: 'Icon (lucide name)', placeholder: 'Spade' },
        { key: 'link', label: 'Link / Anchor', placeholder: '#products' },
      ]} />

      <div className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900/60 p-4" data-testid="section-anchor-reference">
        <div className="text-xs uppercase tracking-wider font-bold text-[color:var(--gold)] mb-2">Available #section anchors</div>
        <p className="text-zinc-400 text-xs mb-3">Paste any of these into a sidebar / top-nav item's "Link" field — clicking the item will smoothly scroll the visitor to that section.</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
          {PAGE_ANCHORS.map((a) => (
            <li key={a.id} className="flex items-center gap-2 text-xs">
              <code className="px-1.5 py-0.5 rounded bg-zinc-950 text-[color:var(--gold)] font-mono text-[11px] border border-zinc-800">{a.id}</code>
              <span className="text-zinc-300">{a.label}</span>
              <button
                onClick={() => { navigator.clipboard?.writeText(a.id); }}
                className="ml-auto text-[10px] text-zinc-500 hover:text-zinc-200"
                data-testid={`copy-anchor-${a.id.replace('#', '')}`}
              >Copy</button>
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
}
